import { offersConstants } from '../../constants/offers';
import { find } from 'lodash';

export const setGeoToOffers = store => next => action => {
  if (action.type === offersConstants.GET_LIST_SUCCESS) {
    if (action.offers !== undefined) {
      const state = store.getState();
      const countries = state.app.globalSettings.countries;
      const offers = action.offers;

      for (let i = 0; i < offers.length; i++) {
        let geo = offers[i].geo;
        let countriesList = [];

        for (let j = 0; j < geo.length; j++) {
          const result = find(countries, { id: geo[j] });

          if (result !== undefined) {
            countriesList.push(result.title);
          }
        }

        offers[i] = { ...offers[i], countriesList };
      }
    }
  }

  if (action.type === offersConstants.SET_OFFER_SUCCESS) {
    if (action.offer !== undefined) {
      const state = store.getState();
      const countries = state.app.globalSettings.countries;
      const offer = action.offer;
      const geo = offer.geo;

      let countriesList = [];

      for (let i = 0; i < geo.length; i++) {
        const result = find(countries, { id: geo[i] });

        if (result !== undefined) {
          countriesList.push(result.title);
        }
      }

      action.offer = { ...offer, countriesList };
    }
  }

  return next(action);
};
